import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "select-wrapper colxl" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["title"]
const _hoisted_4 = ["value", "id"]
const _hoisted_5 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_control_error_message = _resolveComponent("control-error-message")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: _ctx.compId,
      class: _normalizeClass({ 'visuallyhidden': _ctx.labelHidden })
    }, [
      _createTextVNode(_toDisplayString(_ctx.$t(_ctx.i18nLabel)) + " ", 1),
      (_ctx.isRequired())
        ? (_openBlock(), _createElementBlock("abbr", {
            key: 0,
            title: _ctx.$t('common.form.required')
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("sup", null, "*", -1)
          ]), 8, _hoisted_3))
        : _createCommentVNode("", true)
    ], 10, _hoisted_2),
    _createElementVNode("select", {
      value: _ctx.modelValue || '',
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChange(($event.target as HTMLInputElement).value))),
      id: _ctx.compId,
      class: "custom-select form-group"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableValues, (option, index) => {
        return (_openBlock(), _createElementBlock("option", {
          key: index,
          value: option.value
        }, _toDisplayString(option.label), 9, _hoisted_5))
      }), 128))
    ], 40, _hoisted_4),
    (_ctx.validation && _ctx.validation.$error)
      ? (_openBlock(), _createBlock(_component_control_error_message, {
          key: 0,
          validation: _ctx.validation,
          i18nLabel: _ctx.i18nLabel
        }, null, 8, ["validation", "i18nLabel"]))
      : _createCommentVNode("", true)
  ]))
}